import React, { createContext, useContext, type ReactNode } from 'react';
import {
	type Provider,
	useDeploymentProviders as useCommonDeploymentProviders,
} from '@atlassian/jira-software-deployments-devops-provider';

import type { ServiceQueryResultWithFetch } from '@atlassian/jira-software-deployments-service-query-types';

const DeploymentProviderContext = createContext<ServiceQueryResultWithFetch<Provider[]> | null>(
	null,
);

export const DeploymentProviderServiceQueryResultProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const deploymentProvidersResult = useCommonDeploymentProviders();

	return (
		<DeploymentProviderContext.Provider value={deploymentProvidersResult}>
			{children}
		</DeploymentProviderContext.Provider>
	);
};

export const useDeploymentProviders = (): ServiceQueryResultWithFetch<Provider[]> => {
	const result = useContext(DeploymentProviderContext);

	if (result === null) {
		throw new Error('Missing DeploymentProviderContext');
	}

	return result;
};
